import { useEffect } from 'react';

import PropTypes from 'prop-types';

import AppLoader from '@components/common/AppLoader';
import { useAuthStore } from '@store';

function AuthBootstrap({ children }) {
  const isHydrated = useAuthStore((state) => state.isHydrated);
  const hydrateAuth = useAuthStore((state) => state.hydrateAuth);

  useEffect(() => {
    hydrateAuth();
  }, [hydrateAuth]);

  if (!isHydrated) {
    return <AppLoader fullHeight label="Restoring session…" />;
  }

  return children;
}

AuthBootstrap.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthBootstrap;
